import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from '../shared/services/api.service';

import { Linkpage, Linkitem } from '../shared/models';
import { environment } from '../../environments/environment';
import { Filters } from '../shared/helpers/filters';

@Component({
    selector: 'app-linkpages',
    templateUrl: './linkpages.component.html',
    styleUrls: ['./linkpages.component.scss'],
    standalone: false
})
export class LinkpagesComponent implements OnInit {
	linkpage: Linkpage;
	done: boolean = false;
	baseUrl: string = environment.server_url;

  constructor(private api: ApiService,
  						private router: Router,
  						private route: ActivatedRoute) { }

  ngOnInit(): void {
  	this.route.paramMap.subscribe(
  		res => {
  			if(res["params"] && res["params"].link_name) {
          this._load(res["params"].link_name);
  			} else {
  				alert("Não foi possível obter o link");
  			}
  		}
  	);
  }

  private _load(linkName: string) {
  	this.api.index('linkpages', {
  		q: {
  			name: linkName
  		}
  	}).subscribe(
  		res => {
  			if(res[0]) {
  				res[0].linkitems = Filters.orderAlphabetically(res[0].linkitems, 'order', true);
  				this.linkpage = res[0];
  			}
  			this.done = true;
  			console.log(this.linkpage);
  		},
  		err => {
  			console.log(err);
  			this.done = true;
  			alert("Link inválido");
  		}
  	);
  }
}
